import { Injectable, inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { map, Observable } from 'rxjs';
import { Claims } from '../constants/enums/claims.enum';
import { Roles } from '../constants/enums/roles.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthorisationService {
  private readonly _authService = inject(AuthService);

  public isInRole(userRole: Roles): Observable<boolean> {
    return this._authService.user$.pipe(
      map((user) => {
        if (user?.[Claims.RoleIdentityClaim]) {
          return user[Claims.RoleIdentityClaim].some((role: string) => role === userRole);
        }
        return false;
      })
    );
  }
}
